var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22638_4070)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "url(#paint0_radial_22638_4070)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.127 461.764L735.857 534.447V430.25L498.127 357.567V461.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.996 492.997C343.206 492.997 288.143 548.067 288.143 620.939C288.143 693.81 343.175 748 415.996 748C488.817 748 543.85 692.93 543.85 620.939C543.85 548.948 488.817 492.997 415.996 492.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.127 314.197L735.857 386.88V282.683L498.127 210V314.197Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_22638_4070",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1024) rotate(135) scale(1448.15 1131.71)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E4022D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5615A4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22638_4070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKion);
export default __webpack_public_path__ + "static/media/kion.8fc754f448c7c6e237b0a541caeba241.svg";
export { ForwardRef as ReactComponent };